import React, {Component} from 'react'
import Authentication from '../../../modules/Authentication'
import {Alert, Button, Col, Form, Input, Row} from 'antd'

import InfoTooltip from '../../../elements/InfoTooltip'
import {compose} from 'recompose'

const FormItem = Form.Item

class Password extends Component {
  auth = new Authentication()
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  }

  handleConfirmBlur = e => {
    const value = e.target.value
    this.setState({confirmDirty: this.state.confirmDirty || !!value})
  }
  checkPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue('newPassword')) {
      callback('Two passwords that you enter is inconsistent!')
    } else {
      callback()
    }
  }
  checkConfirm = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirmPassword'], {force: true})
    }
    callback()
  }

  render() {
    const {getFieldDecorator} = this.props.form
    const {updating, updatePassword, expired} = this.props
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 6},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 14},
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 6,
        },
      },
    }
    const info = (
      <div>
        <h3>Requirements</h3>
        <ul>
          <li>Length of between 8 to 30</li>
          <li>Minimum of 1 lowercase</li>
          <li>Minimum of 1 uppercase</li>
          <li>Minimum of 1 digit</li>
          <li>Minimum of 1 special character</li>
          <li> </li>
          <li>Note: Don't use your personal password</li>
        </ul>
      </div>
    )
    const expiredMsg = (
      <div>Your password has expired. please change your password.</div>
    )
    return (
      <Form>
        <Row>
          <Col span={14} offset={6}>
            {expired === true && (
              <Alert
                style={{
                  marginBottom: '20px',
                  marginTop: '20px',
                  width: '100%',
                }}
                message={expiredMsg}
                type="warning"
              />
            )}
            <Alert
              style={{
                marginBottom: '20px',
                marginTop: '20px',
                width: '100%',
              }}
              message={info}
              type="info"
            />
          </Col>
        </Row>
        <FormItem {...formItemLayout} label="Current Password" hasFeedback>
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: 'Please input your password!',
              },
            ],
          })(<Input type="password" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="New Password" hasFeedback>
          {getFieldDecorator('newPassword', {
            rules: [
              {
                required: true,
                message: 'Please input your new password!',
              },
              {
                validator: this.checkConfirm,
              },
            ],
          })(<Input type="password" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Confirm Password" hasFeedback>
          {getFieldDecorator('confirmPassword', {
            rules: [
              {
                required: true,
                message: 'Please confirm your password!',
              },
              {
                validator: this.checkPassword,
              },
            ],
          })(<Input type="password" onBlur={this.handleConfirmBlur} />)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={
            <InfoTooltip
              title={'What do you want other to call you?'}
              value={'Nickname'}
            />
          }
          hasFeedback>
          {getFieldDecorator('nickname', {
            rules: [{whitespace: true}],
          })(<Input />)}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button
            onClick={updatePassword}
            loading={updating}
            type="primary"
            htmlType="submit">
            Update
          </Button>
        </FormItem>
      </Form>
    )
  }
}

Password.propTypes = {}
Password.defaultProps = {}

export default compose(Form.create())(Password)
